import * as React from 'react';

export function EduStandard() {
  return (
    <section className="edu-standard">
      <style>{`
        .edu-standard {
          padding: 72px 24px;
          background: #fff;
        }
        .edu-standard-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .edu-standard h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
        }
        .edu-standard .subtitle {
          font-size: 18px;
          color: #666;
          margin: 0 0 32px;
        }
        .edu-checklist {
          list-style: none;
          padding: 0;
          margin: 0 0 28px;
        }
        .edu-checklist li {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 14px 18px;
          font-size: 16px;
          color: #333;
          font-weight: 500;
          border-radius: 10px;
          margin-bottom: 8px;
          background: #f0fdf0;
        }
        .edu-checklist li i {
          color: #1EAA25;
          font-size: 18px;
          flex-shrink: 0;
        }
        .edu-standard .closing {
          font-size: 16px;
          color: #555;
          font-style: italic;
          margin: 0;
        }
        @media (max-width: 640px) {
          .edu-standard h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="edu-standard-inner">
        <h2>Lo que garantizamos</h2>
        <p className="subtitle">Pensado para comedores que necesitan consistencia</p>
        <ul className="edu-checklist">
          <li><i className="fa fa-check-circle" /> Productos frescos y de temporada</li>
          <li><i className="fa fa-check-circle" /> Entrega programada y puntual</li>
          <li><i className="fa fa-check-circle" /> Precios estables y transparentes</li>
          <li><i className="fa fa-check-circle" /> Pedido online las 24 hs</li>
          <li><i className="fa fa-check-circle" /> Historial de compras para control presupuestario</li>
        </ul>
        <p className="closing">No entregamos lo que no le daríamos de comer a nuestros propios hijos.</p>
      </div>
    </section>
  );
}
